import { updateWishlist } from '@app/services/lookbookRepository';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Lookbook } from '@typings';

import { LOOKBOOK_WISHLIST_BY_ID_QUERY_KEY } from './useLookbookWishlist';

interface Payload {
  lookbookId: string;
  wishlistId: string;
  data: Lookbook.UpdateWishlistDTO;
}

export const useUpdateLookbookWishlist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data, lookbookId, wishlistId }: Payload) => updateWishlist(lookbookId, wishlistId, data),
    onSuccess: (_, { wishlistId, lookbookId }) => {
      queryClient.invalidateQueries({ queryKey: [LOOKBOOK_WISHLIST_BY_ID_QUERY_KEY, lookbookId, wishlistId] });
    },
  });
};
